var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "box" } },
    [
      _c(
        "a-card",
        {
          staticStyle: {
            "box-sizing": "border-box",
            "border-radius": "0 !important",
          },
        },
        [
          !_vm.appId
            ? _c("a-divider", [_vm._v("请选择应用APPID")])
            : _vm.noConfigText
            ? _c("a-divider", [_vm._v("您尚未配置任何支付方式")])
            : _vm._e(),
          _vm.payTestShow()
            ? _c(
                "div",
                { staticClass: "paydemo", staticStyle: { width: "100%" } },
                [
                  _c("Header"),
                  _c("div", { staticStyle: { height: "80px" } }),
                  _c(
                    "div",
                    { staticClass: "paydemo-type-content" },
                    [
                      _c(
                        "a-form-model",
                        {
                          ref: "form",
                          attrs: {
                            "label-col": { span: 5 },
                            model: _vm.form,
                            rules: _vm.rules,
                            "wrapper-col": { span: 18 },
                          },
                          on: { submit: _vm.handleSubmit },
                        },
                        [
                          _c(
                            "a-row",
                            [
                              _c("a-col", { attrs: { span: 1 } }, [
                                _c("div", {
                                  staticStyle: { width: "100%", height: "1px" },
                                }),
                              ]),
                              _c(
                                "a-col",
                                { attrs: { span: 11 } },
                                [
                                  _c(
                                    "a-form-model-item",
                                    { attrs: { label: "购买项目" } },
                                    [
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            content:
                                              "该项目购买完成，直接使用邮箱发送链接处理即可。",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            {
                                              attrs: {
                                                border: "",
                                                label: "auto",
                                              },
                                              model: {
                                                value: _vm.form.saletype,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "saletype",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.saletype",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.tobonumber.title) +
                                                  " "
                                              ),
                                              _c(
                                                "b",
                                                {
                                                  staticStyle: { color: "red" },
                                                },
                                                [
                                                  _vm._v(
                                                    "￥" +
                                                      _vm._s(
                                                        _vm.tobonumber.price
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            content: "一对一专人服务",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-radio",
                                            {
                                              attrs: {
                                                border: "",
                                                label: "person",
                                              },
                                              model: {
                                                value: _vm.form.saletype,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "saletype",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.saletype",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.tobonumberperson.title
                                                ) + " "
                                              ),
                                              _c(
                                                "b",
                                                {
                                                  staticStyle: { color: "red" },
                                                },
                                                [
                                                  _vm._v(
                                                    "￥" +
                                                      _vm._s(
                                                        _vm.tobonumberperson
                                                          .price
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-form-item",
                                    { attrs: { label: "购买数量" } },
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          min: 1,
                                          max: 10,
                                          label: "描述文字",
                                        },
                                        model: {
                                          value: _vm.form.totalnum,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "totalnum", $$v)
                                          },
                                          expression: "form.totalnum",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-form-model-item",
                                    {
                                      attrs: {
                                        label: "购买单位",
                                        prop: "company",
                                      },
                                    },
                                    [
                                      _c("a-input", {
                                        staticStyle: { width: "70%" },
                                        attrs: {
                                          disabled: true,
                                          placeholder: "请输入购买单位全称",
                                        },
                                        model: {
                                          value: _vm.form.company,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "company", $$v)
                                          },
                                          expression: "form.company",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-form-model-item",
                                    {
                                      attrs: {
                                        label: "信用代码",
                                        prop: "yscode",
                                      },
                                    },
                                    [
                                      _c("a-input", {
                                        staticStyle: { width: "70%" },
                                        attrs: {
                                          disabled: true,
                                          placeholder: "请输入统一社会信用代码",
                                        },
                                        model: {
                                          value: _vm.form.yscode,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.form, "yscode", $$v)
                                          },
                                          expression: "form.yscode",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-form-model-item",
                                    { attrs: { label: "制图要求" } },
                                    [
                                      _c(
                                        "b",
                                        { staticStyle: { color: "red" } },
                                        [
                                          _vm._v(
                                            "图片大小请控制在1M以内，印章占图片尺寸要达到80%"
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "a-form-model-item",
                                    { attrs: { label: "上传示例" } },
                                    [
                                      _c("el-image", {
                                        staticStyle: {
                                          display: "block",
                                          width: "120px",
                                          height: "120px",
                                        },
                                        attrs: { src: _vm.shili },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("a-col", { attrs: { span: 1 } }, [
                                _c("div", {
                                  staticStyle: { width: "100%", height: "1px" },
                                }),
                              ]),
                              _c("a-col", { attrs: { span: 11 } }, [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "a-form-model-item",
                                      {
                                        attrs: {
                                          label: "电子邮箱",
                                          prop: "email",
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          staticStyle: { width: "70%" },
                                          attrs: {
                                            disabled: true,
                                            placeholder:
                                              "请输入用于接收电子发票有效邮箱有效邮箱，请使用网易或QQ邮箱",
                                          },
                                          model: {
                                            value: _vm.form.email,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.form, "email", $$v)
                                            },
                                            expression: "form.email",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "a-form-model-item",
                                      {
                                        attrs: {
                                          label: "联系人",
                                          prop: "name",
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          staticStyle: { width: "70%" },
                                          attrs: {
                                            disabled: true,
                                            placeholder: "请输入联系人姓名",
                                          },
                                          model: {
                                            value: _vm.form.name,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.form, "name", $$v)
                                            },
                                            expression: "form.name",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "a-form-model-item",
                                      {
                                        attrs: {
                                          label: "手机号码",
                                          prop: "phone",
                                        },
                                      },
                                      [
                                        _c("a-input", {
                                          staticStyle: { width: "70%" },
                                          attrs: {
                                            disabled: true,
                                            placeholder: "请输入11位手机号码",
                                          },
                                          model: {
                                            value: _vm.form.phone,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.form, "phone", $$v)
                                            },
                                            expression: "form.phone",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "a-form-item",
                                      { attrs: { label: "关于发票" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "red",
                                              cursor: "pointer",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "发票将在订单支付成功后3-5个工作日内发送到您填写的电子邮箱内。"
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "row",
                            "justify-content": "center",
                            "padding-top": "30px",
                          },
                        },
                        [
                          _vm.companyinfostatus
                            ? _c(
                                "a-button",
                                {
                                  staticStyle: {
                                    "font-weight": "bold",
                                    width: "200px",
                                    height: "40px",
                                    "font-size": "15px",
                                  },
                                  attrs: { type: "danger" },
                                  on: { click: _vm.login },
                                },
                                [_vm._v("登录后提交订单")]
                              )
                            : _vm._e(),
                          !_vm.companyinfostatus
                            ? _c(
                                "a-button",
                                {
                                  staticStyle: {
                                    "font-weight": "bold",
                                    width: "200px",
                                    height: "40px",
                                    "font-size": "15px",
                                  },
                                  attrs: {
                                    disabled: _vm.disabledlook,
                                    type: "danger",
                                  },
                                  on: { click: _vm.handleSubmit },
                                },
                                [_vm._v(" 提交订单 ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "row",
                            "justify-content": "center",
                            color: "#132b75",
                            "line-height": "50px",
                            cursor: "pointer",
                          },
                          on: { click: _vm.homepay },
                        },
                        [_vm._v("返回首页")]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "row",
                            "align-items": "center",
                            "justify-content": "center",
                          },
                          attrs: { id: "bottomtoolbar" },
                        },
                        [
                          _c("div", { attrs: { id: "sealintro" } }, [
                            _c("div", [
                              _vm._v(" 本服务购买后"),
                              _c("span", { staticStyle: { color: "red" } }, [
                                _vm._v("不可退款"),
                              ]),
                              _vm._v("，敬请理解！ "),
                            ]),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: { title: "流程说明", width: "40%" },
          on: { ok: _vm.handleOkmodd },
          model: {
            value: _vm.visiblemodd,
            callback: function ($$v) {
              _vm.visiblemodd = $$v
            },
            expression: "visiblemodd",
          },
        },
        [
          _c("p", [
            _c("b", [
              _vm._v(
                "灌装流程说明：企业在此下单后，前往证书运维管理平台上自助抠账使用。"
              ),
            ]),
          ]),
          _c("p", [_vm._v("Some contents...")]),
          _c("p", [_vm._v("Some contents...")]),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            visible: _vm.dialogVisible,
            title: "自动化制图服务",
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v("确认")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { attrs: { id: "successbox" } }, [
            _c(
              "div",
              { staticClass: "infotip", staticStyle: { "line-height": "2" } },
              [
                _c("p", { staticStyle: { "text-indent": "2em" } }, [
                  _vm._v(" 感谢您订购智能图片处理服务。"),
                  _c("b", { staticStyle: { color: "red" } }, [
                    _vm._v("本服务一经出售，不接受退款申请"),
                  ]),
                  _vm._v("。本次专属链接只能处理"),
                  _c("b", { staticStyle: { color: "red" } }, [_vm._v("3次")]),
                  _vm._v("图片，处理"),
                  _c("b", { staticStyle: { color: "red" } }, [_vm._v("3次")]),
                  _vm._v(
                    "图片后，本次链接自动失效。专属链接在订单支付成功后，自动发送到您的邮箱内，请前往邮箱内点击链接使用。"
                  ),
                  _c("b", { staticStyle: { color: "red" } }, [
                    _vm._v(
                      "注：一次只能上传一张图片，并且图上只允许出现一个图片"
                    ),
                  ]),
                ]),
              ]
            ),
          ]),
        ]
      ),
      _c("pay-test-modal", {
        ref: "payTestModal",
        on: {
          closeBarCode: function ($event) {
            _vm.$refs.payTestBarCode.visible = false
          },
        },
      }),
      _c("pay-test-bar-code", {
        ref: "payTestBarCode",
        on: {
          CodeAgainChange: _vm.testCodeChange,
          barCodeValue: _vm.barCodeChange,
        },
      }),
      _c("Footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }